import Stack from 'components/commons/stack';
import { Skeleton } from 'components/widgets/skeleton';
import SkeletonText from 'modules/shipping/skeleton-type/skeleton-text';
import SkeletonTextLabel from 'modules/shipping/skeleton-type/skeleton-text-label';

import { SectionContent, ShippingRouteContainer } from './style';

export default function SearchTicketLoading() {
  return (
    <>
      <ShippingRouteContainer>
        <SectionContent>
          <Stack direction="horizontal" justify="between">
            <SkeletonTextLabel />
            <Stack.Item
              direction="horizontal"
              justify="around"
              grow
              css={{ '@md': { display: 'none' } }}
            >
              <SkeletonTextLabel />
              <SkeletonTextLabel />
            </Stack.Item>
          </Stack>
          <Stack direction="horizontal" gap="xxs" justify="between">
            <Stack.Item grow>
              <Stack gap="xs">
                <SkeletonTextLabel />
                <SkeletonText />
              </Stack>
            </Stack.Item>
            <Stack.Item grow>
              <Stack gap="xs">
                <SkeletonTextLabel />
                <SkeletonText />
              </Stack>
            </Stack.Item>
            <Stack.Item grow>
              <Stack gap="xs">
                <SkeletonTextLabel />
                <SkeletonText />
              </Stack>
            </Stack.Item>
            <Stack.Item
              grow
              css={{ display: 'none', '@md': { display: 'flex' } }}
            >
              <Stack gap="xs">
                <SkeletonTextLabel />
                <SkeletonText />
              </Stack>
            </Stack.Item>
            <Stack.Item
              grow
              css={{ display: 'none', '@md': { display: 'flex' } }}
            >
              <Stack gap="xs">
                <SkeletonTextLabel />
                <SkeletonText />
              </Stack>
            </Stack.Item>
            <Stack.Item grow justify="center" alignItems="end">
              <Skeleton
                css={{
                  width: 24,
                  height: 24,
                  borderRadius: 4,
                  '@md': { width: 120, height: 48 },
                }}
              />
            </Stack.Item>
          </Stack>
        </SectionContent>
      </ShippingRouteContainer>
      F
    </>
  );
}
